module.exports = "https://cdn.realtymogul.com/static/media/closeX_blk.685aa7b6.svg";